import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  OnInit,
  OnChanges,
  inject,
} from '@angular/core';

import { CustomIcon, IconLibrary, SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { ElementActions, ElementTypes, GaContext, Step } from '@fcom/common/interfaces';
import { BOOKING_STEPS } from '@fcom/common/config/booking-config';
import { GtmService } from '@fcom/common/gtm';

import { ButtonTheme, IconButtonSize, IconButtonTheme } from '../../components/buttons';
import { IconPosition } from '../../components/icons';
import { Breadcrumb } from '../../../common-booking/interfaces/booking-header-interfaces';

@Component({
  selector: 'fcom-stepper-v2',
  templateUrl: './stepper-v2.component.html',
  styleUrl: './stepper-v2.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StepperV2Component implements OnInit, OnChanges {
  private gtmService = inject(GtmService);

  readonly CustomIcon = CustomIcon;
  readonly IconLibrary = IconLibrary;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly ButtonTheme = ButtonTheme;
  readonly IconPosition = IconPosition;
  readonly IconButtonSize = IconButtonSize;
  readonly IconButtonTheme = IconButtonTheme;
  readonly BOOKING_STEPS = BOOKING_STEPS;

  activeIndex: number;

  @Input()
  breadcrumbs: Breadcrumb[];

  @Input()
  currentStep: Step;

  @Input()
  isTabletDown: boolean;

  @Output()
  stepClick: EventEmitter<Breadcrumb> = new EventEmitter();

  ngOnInit(): void {
    this.findActiveIndex();
  }

  ngOnChanges(): void {
    this.findActiveIndex();
  }

  findActiveIndex(): void {
    (this.breadcrumbs || []).forEach((breadcrumb, i) => {
      if (breadcrumb.active) {
        this.activeIndex = i;
      }
    });
  }

  onBreadcrumbClick(breadcrumb: Breadcrumb, index: number): void {
    if (breadcrumb.disabled) {
      return;
    }

    if (index < this.activeIndex) {
      this.stepClick.emit(breadcrumb);
      this.gtmService.trackElement(
        `new-stepper-step-${index + 1}-${breadcrumb.name}`,
        GaContext.BOOKING_FLOW,
        ElementTypes.BUTTON,
        undefined,
        ElementActions.CLICK
      );
    }
  }

  handleDisabledClick(event: MouseEvent, step: Breadcrumb, index: number): void {
    if (step.disabled || index > this.activeIndex) {
      event.preventDefault();
      this.gtmService.trackElement(
        `new-stepper-disabled-step-${index + 1}-${step.name}-clicked`,
        GaContext.BOOKING_FLOW,
        ElementTypes.BUTTON,
        undefined,
        ElementActions.CLICK
      );
    }
  }
}
